// extracted by mini-css-extract-plugin
export default {"AddRecipeDialogField":"AddRecipeDialog_AddRecipeDialogField__hvREw"};